import { ReactNode } from "react";

import { EventInput } from "@fullcalendar/core/index.js";
import { Stack } from "@mui/material";
import { format } from "date-fns";

import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";

import { CalendarBase } from "./CalendarBase";
import { ListCalendarHeader } from "./components/calendar-header/ListCalendarHeader";
import { useCalendar } from "./hooks/useCalendar";

interface Props<T> {
  events: T[];
  mapEvent: (event: T) => EventInput;
  noEventsMessage: string;
  renderEvent: (event: T) => ReactNode;
  onDateChange: (startDate: Date, endDate: Date) => void;
  onEventClick: (event: T) => void;
  onCreateClick?: () => void;
  customHeaderFilter?: ReactNode;
  isLoading: boolean;
}

export function ListCalendar<T>(props: Props<T>) {
  const {
    events,
    mapEvent,
    noEventsMessage,
    renderEvent,
    onDateChange,
    onEventClick,
    onCreateClick,
    customHeaderFilter,
    isLoading,
  } = props;
  const { language } = useLanguageContext();
  const { calendarRef, currentDate, goNext, goPrev, goToday, calendarEvents, handleEventContent, handleEventClick } =
    useCalendar({ events, mapEvent, renderEvent, onEventClick });

  return (
    <Stack height="100%" flex={1} borderRadius={0.5} border={"1px solid"} borderColor={"fsw.blue-10"}>
      <ListCalendarHeader
        title={format(currentDate, "EEEE, dd. MMMM yyyy", { locale: locales[language] })}
        onPrevClick={goPrev}
        onNextClick={goNext}
        onTodayClick={goToday}
        onCreateClick={onCreateClick}
        customHeaderFilter={customHeaderFilter}
      />

      <CalendarBase
        calendarRef={calendarRef}
        calendarEvents={calendarEvents}
        handleEventContent={handleEventContent}
        handleEventClick={handleEventClick}
        noEventsMessage={noEventsMessage}
        onDateChange={onDateChange}
        isLoading={isLoading}
        initialView="listDay"
        dayHeaderContent={() => null}
      />
    </Stack>
  );
}
